/** Chaves de widgets do Dashboard de atendimentos (0 = oculto, 1 = exibido). */
export const DASH_VISIBILITY_KEYS = [
  { key: 'qualityRating', label: 'Avaliações de qualidade' },
  { key: 'locations', label: 'Chamados entre locais' },
  { key: 'period', label: 'Chamados no período' },
  { key: 'availability', label: 'Índice de disponibilidade' },
  { key: 'equipment', label: 'Chamados por equipamento' },
  { key: 'defects', label: 'Problemas frequentes' },
];

export function normalizeDashboardVisibility(cfg) {
  const src =
    cfg && typeof cfg === 'object' && cfg.dashboardVisibility && typeof cfg.dashboardVisibility === 'object'
      ? cfg.dashboardVisibility
      : {};
  const out = {};
  for (const { key } of DASH_VISIBILITY_KEYS) {
    const v = src[key];
    out[key] = v === 0 || v === false || v === '0' ? 0 : 1;
  }
  return out;
}

export function isDashWidgetVisible(visibility, key) {
  return Number(visibility?.[key] ?? 1) === 1;
}

/** Blocos da aba Visão geral (overview_visibility). completedOs / suprimentos_entregues nascem ocultos. */
export const OVERVIEW_VISIBILITY_KEYS = [
  { key: 'openOs', label: 'OS em aberto', defaultOn: 1 },
  { key: 'openSupplies', label: 'Suprimentos em aberto', defaultOn: 1 },
  { key: 'contracts', label: 'Contratos', defaultOn: 1 },
  { key: 'satisfaction', label: 'Satisfação e atendimento', defaultOn: 1 },
  { key: 'completedOs', label: 'OS concluídas', defaultOn: 0 },
  { key: 'suprimentos_entregues', label: 'Suprimentos entregues', defaultOn: 0 },
];

export const OVERVIEW_MAX_VISIBLE = 4;

export function normalizeOverviewVisibility(src) {
  const from = src && typeof src === 'object' && !Array.isArray(src) ? src : {};
  const out = {};
  for (const { key, defaultOn } of OVERVIEW_VISIBILITY_KEYS) {
    const v = from[key];
    if (v === 0 || v === false || v === '0') out[key] = 0;
    else if (v === 1 || v === true || v === '1') out[key] = 1;
    else out[key] = defaultOn;
  }
  let shown = OVERVIEW_VISIBILITY_KEYS.filter(({ key }) => out[key] === 1).length;
  for (let i = OVERVIEW_VISIBILITY_KEYS.length - 1; i >= 0 && shown > OVERVIEW_MAX_VISIBLE; i -= 1) {
    const { key } = OVERVIEW_VISIBILITY_KEYS[i];
    if (out[key] === 1) {
      out[key] = 0;
      shown -= 1;
    }
  }
  return out;
}

export function isOverviewCustomized(src) {
  if (!src || typeof src !== 'object') return false;
  const vis = normalizeOverviewVisibility(src);
  return OVERVIEW_VISIBILITY_KEYS.some(({ key, defaultOn }) => vis[key] !== defaultOn);
}

export function withToggledDashVisibility(techCallCfg, key) {
  const base = techCallCfg && typeof techCallCfg === 'object' ? { ...techCallCfg } : {};
  const visibility = normalizeDashboardVisibility(base);
  visibility[key] = visibility[key] === 1 ? 0 : 1;
  return { ...base, dashboardVisibility: visibility };
}
